import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Form, Button, Image } from "react-bootstrap";
import { FILE_FORMAT, FILE_SIZE_LIMIT } from "../../../constant";
import Files from "react-files";
import { createBestPracticesAction } from "../../../actions/userManagement.action";
import {
  uploadFileAction,
  removeFileAction
} from "../../../actions/common.action";
import { get } from "lodash";
import { bindActionCreators } from "redux";
import { isValidArray, FormDataForImage } from "../../../helper";
import { modifyDataForBestPractices } from "../helper";
import { ERROR_MSG, STATUS } from "../../../constant";
import { LoaderPage } from "../../../component/Loader";
import { toast } from "react-toastify";
import { ConfirmationComponent } from "../../ConfirmationComponent";
import PermissionHOC from "../../PermissionHOC";
import IconPlus from "../../../assets/Files-icon.svg";
import { Field } from "../fieldComponent";
import { successToastStyle, errorToastStyle } from "../../../customToast";
export class CreateBestPracticeForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: null,
      description: null,
      groupId: null,
      submitBtnText: "SUBMIT",
      verified: false,
      isApiLoading: STATUS.LOADING,
      files: [],
      defaultSelected: null,
      mandatoryFields: false,
      focused: false,
      isfocused: false,
      dataUnsaved: false,
      allowPrompt: true
    };
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    // Clean up the event listener
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = event => {
    const { togglePopUp } = this.props;
    const { dataUnsaved, allowPrompt } = this.state;

    // Check if the click was outside the modal
    const modalRef =
      this.props.practiceModelRef && this.props.practiceModelRef.current;
    const isOutsideModal = modalRef && !modalRef.contains(event.target);

    // Check if the click was on the vertical scrollbar
    const isClickOnScrollbar =
      event.clientX > window.innerWidth - 7 &&
      (event.clientY >= 0 && event.clientY <= window.innerHeight);

    // If the click is outside the modal and not on the scrollbar
    if (isOutsideModal && !isClickOnScrollbar) {
      console.log(
        "Clicked outside the modal, but modal will not close.",
        dataUnsaved
      );
      if (dataUnsaved && allowPrompt && event.button === 0) {
        event.preventDefault();
        const confirmLeave = window.confirm(
          "You have unsaved changes, are you sure you want to leave?"
        );

        if (confirmLeave) {
          togglePopUp();
          return;
        }
      }
    }
  };

  handleChange = event => {
    const { name, value } = event.target;
    const data = {
      [name]: value
    };
    if (name === "groupId") {
      data["groupRoles"] = [];
    }
    this.setState(prevState => ({
      ...data,
      dataChangeStatus: true,
      isEmailModified: name === "email" ? prevState.email !== value : false,
      dataUnsaved: true
    }));
  };

  validateForm = () => {
    let { description, title, defaultSelected, files, groupId } = this.state;
    const isTitleError = title !== null && title !== "";
    const isDescriptionError = description !== null && description !== "";
    const isDefaultSelected =
      groupId !== null && groupId !== "" && groupId !== undefined;

    const isFormValid =
      isDescriptionError &&
      isDefaultSelected &&
      isTitleError &&
      files.length > 0;

    this.setState({
      mandatoryFields: !isFormValid
    });

    return isFormValid;
  };

  handleOtpModal = event => {
    event.preventDefault();
    let isValidData = this.validateForm();
    if (isValidData) {
      this.openConfirmationAlert();
    } else {
      toast.error(
        <p className="toast-text-alignment">{ERROR_MSG.INVALID_FORM}</p>,
        errorToastStyle
      );
    }
  };

  onError = (value, key) => {
    this.setState(prevState => {
      const error = isValidArray(prevState[key])
        ? { error: !prevState[key].length, message: ERROR_MSG.DEFAULT_MSG }
        : value;
      return {
        errors: {
          ...prevState.errors,
          [key]: error
        }
      };
    });
  };

  openConfirmationAlert = () => {
    this.setState(prevState => ({
      showAlert: !prevState.showAlert,
      allowPrompt: !prevState.allowPrompt
    }));
  };

  onSubmit = async () => {
    const {
      createBestPracticesAction,
      togglePopUp,
      callApiOnSuccess
    } = this.props;
    const { userId, id, showOrganization } = this.state;
    const params = { ...this.state, userID: userId };
    if (!params.alternateMobileNumber) delete params.alternateMobileNumber;
    if (!showOrganization) delete params.organisation;
    this.setState({ isApiLoading: STATUS.LOADING });
    togglePopUp();

    const registerResponse = await createBestPracticesAction(undefined, {
      ...modifyDataForBestPractices(params),
      id
    });

    callApiOnSuccess();

    if (registerResponse) {
      const { status, message, error } = get(registerResponse, "data", {});
      status
        ? toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          )
        : (isValidArray(error) &&
            error.forEach(msg => {
              toast.error(
                <p className="toast-text-alignment">{msg}</p>,
                errorToastStyle
              );
            })) ||
          toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
      this.setState({ isApiLoading: STATUS.SUCCESS, dataUnsaved: false });
      this.openConfirmationAlert();
    }
  };

  /**
   *  For upload files
   * @param files
   * @returns {Promise<void>}
   */
  onFilesChange = async file => {
    const { uploadFileDispatch } = this.props;
    const { files, dataUnsaved } = this.state;
    try {
      if (!this.inValidFile) {
        const attachmentPayload = FormDataForImage(file, "file");
        attachmentPayload.append("isMis", false);
        const response = await uploadFileDispatch(undefined, attachmentPayload);
        if (response) {
          const { status, message, data } = response;
          if (status) {
            this.setState({
              files: [...files, { ...data, extension: file[0].extension }],
              dataUnsaved: true
            });
          } else {
            toast.error(
              <p className="toast-text-alignment">{message}</p>,
              errorToastStyle
            );
          }
        } else {
          toast.error(
            <p className="toast-text-alignment">
              {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
            </p>,
            errorToastStyle
          );
        }
      }
      this.inValidFile = false;
    } catch (e) {
      toast.error(
        <p className="toast-text-alignment">{e.message}</p>,
        errorToastStyle
      );
    }
  };

  onFilesError = file => {
    if (file && file.message) {
      toast.error(
        <p className="toast-text-alignment">
          The file exceeds the maximum size limit of 10 MB
        </p>,
        errorToastStyle
      );
    } else {
      toast.error(
        <p className="toast-text-alignment">Not a valid file type</p>,
        errorToastStyle
      );
    }
    this.inValidFile = true;
  };

  /**
   * files upload
   * @returns {*[]}
   */
  createFileTemplate = () => {
    const { files } = this.state;
    return files.map((value, index) => {
      return (
        <div className="uploaded-file">
          <div
            className="remove-file"
            onClick={() => {
              this.removeFile(value, index);
            }}
          />
          <div className="file-detail">
            <div className="upload-icon">{value.name.split(".").pop()}</div>
          </div>
          <a
            className="best-practice-file-name"
            target="_blank"
            href={value.s3Url}
          >
            {value.name}
          </a>
        </div>
      );
    });
  };

  removeFile = async (file, index) => {
    const { removeFileDispatch } = this.props;
    const { files } = this.state;
    try {
      const response = await removeFileDispatch(undefined, {
        fid: file.id
      });
      if (response) {
        const { status, message } = response;
        if (status) {
          files.splice(index, 1);
          toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          );
          this.setState({ files });
        } else {
          toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
        }
      } else {
        toast.error(
          <p className="toast-text-alignment">
            {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
          </p>,
          errorToastStyle
        );
      }
    } catch (e) {
      toast.error(
        <p className="toast-text-alignment">
          {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
        </p>,
        errorToastStyle
      );
    }
  };

  getFilteredData = sortedListingArr => {
    this.setState({
      sortedListingArr: get(sortedListingArr, "sortData", []),
      isSearching: get(sortedListingArr, "isSearching"),
      searchRoles: get(sortedListingArr, "value")
    });
  };

  onAutoSuggestChange = e => {
    this.setState({ groupId: e.target.value });
  };

  handleFocus = () => {
    this.setState({ focused: true });
  };

  topicHandleFocus = () => {
    this.setState({ isfocused: true });
  };

  handleBlur = () => {
    this.setState({ focused: false });
  };

  topicHandleBlur = () => {
    this.setState({ isfocused: false });
  };

  onOptionClick = value => {
    // {
    //   console.log(value.name, value, "value");
    // }
    this.setState(prevState => ({
      defaultSelected: value.name,
      groupId: value,
      errors: {
        ...prevState.errors,
        groupId: {
          error: !value,
          message: !value && ERROR_MSG.DEFAULT_MSG
        }
      },
      dataUnsaved: true
    }));
  };

  onCloseModal = () => {
    this.setState({
      makeUserActiveInfo: null
    });
  };

  closeReadBannerModal = () => {
    this.setState({ isBannerModalVisible: false });
  };

  showReadBannerModal = key => {
    this.setState({ isBannerModalVisible: true, bannerContent: key });
  };

  render() {
    const { onCloseModal } = this;

    const { groups, permission, isImageUpLoading, ministryData } = this.props;
    let {
      submitBtnText,
      title,
      description,
      files,
      errors,
      isApiLoading,
      showAlert,
      defaultSelected,
      mandatoryFields,
      groupId,
      focused,
      isfocused
    } = this.state;

    if (+defaultSelected && isValidArray(get(groups, "data"))) {
      const selectedGroupId = get(groups, "data", []).filter(value => {
        return value.id === +defaultSelected;
      });
      defaultSelected = isValidArray(selectedGroupId)
        ? selectedGroupId[0].name
        : defaultSelected;
    }

    const isTitleError = title === null || title === "";
    const isDescriptionError = description === null || description === "";
    const isDefaultSelected =
      groupId === null || groupId === "" || groupId === undefined;

    return (
      <div className="register-inner create-user-register-inner alignment-user-form">
        <LoaderPage loading={isImageUpLoading === STATUS.LOADING} />
        <ConfirmationComponent
          show={showAlert}
          // isLoading={isApiLoading}
          modalClass={"confirmation-modal"}
          saveHandler={this.onSubmit}
          closeHandler={this.openConfirmationAlert}
          content={"Are you sure you want to do this?"}
        />
        <Form className="signup-form">
          <Form.Group className="category">
            <Form.Label className="label-style">
              Ministry
              <span className="required">*</span>
            </Form.Label>
            <select
              value={defaultSelected}
              onFocus={this.handleFocus}
              onBlur={this.handleBlur}
              isInvalid={isDefaultSelected && mandatoryFields}
              onChange={e => this.onAutoSuggestChange(e)}
              onClick={e => this.onOptionClick(e.target.value)}
              className={` ${
                isDefaultSelected && mandatoryFields
                  ? "form-control is-invalid"
                  : ""
              } best-practices-select ${focused && "selected-ministry"} `}
            >
              <option value="">-Select Ministry-</option>
              {Array.isArray(ministryData.data) &&
                ministryData.data.map((item, index) => (
                  <option value={item.id} key={index}>
                    {item.name}
                  </option>
                ))}
            </select>
            {isDefaultSelected && mandatoryFields ? (
              <span className="error-text">{ERROR_MSG.DEFAULT_MSG}</span>
            ) : null}
          </Form.Group>

          <Form.Group controlId="title">
            <Form.Label className="label-style">
              Topic <span className="required">*</span>
            </Form.Label>
            <Form.Control
              name="title"
              type="text"
              value={title}
              onFocus={this.topicHandleFocus}
              onBlur={this.topicHandleBlur}
              onChange={this.handleChange}
              isInvalid={isTitleError && mandatoryFields}
              placeholder="Enter Topic"
              className={`field-width ${isfocused && "selected"}`}
            />
            {isTitleError && mandatoryFields ? (
              <Form.Control.Feedback type="invalid">
                {ERROR_MSG.DEFAULT_MSG}
              </Form.Control.Feedback>
            ) : null}
          </Form.Group>

          <Form.Group controlId="description">
            <Form.Label className="label-style">
              Description <span className="required">*</span>
            </Form.Label>
            <Form.Control
              as="textarea"
              rows="3"
              name="description"
              value={description}
              onChange={this.handleChange}
              isInvalid={isDescriptionError && mandatoryFields}
              placeholder="Type Description"
            />
            {isDescriptionError && mandatoryFields ? (
              <Form.Control.Feedback type="invalid">
                {ERROR_MSG.DEFAULT_MSG}
              </Form.Control.Feedback>
            ) : null}
          </Form.Group>

          <div className="best-practice-fieldset-heading">
            <h2 data-test="section-label-project-supporting-documents">
              Upload File <span className="required">*</span>
            </h2>
          </div>
          <div className="d-flex flex-wrap best-practice-file uploaded-file-wrapper">
            {this.createFileTemplate()}
            <Form.Group className="best-practice-field-file multiple-attache-file">
              <Files
                className="best-practices-add-files"
                onChange={this.onFilesChange}
                onError={this.onFilesError}
                multiple={false}
                accepts={FILE_FORMAT}
                maxFileSize={FILE_SIZE_LIMIT.OTHER_FORMATS}
                minFileSize={0}
                isInvalid={files == null && mandatoryFields}
                clickable
                ref={elem => {
                  this.files = elem;
                }}
                data-test="add-files"
              >
                <div>
                  <Image src={IconPlus} alt="Plus Icon" />
                  <div
                    className="add-file-text pt-2"
                    data-test="label-add-document"
                  >
                    Add
                  </div>
                </div>
              </Files>
            </Form.Group>
          </div>
          {files.length === 0 && mandatoryFields ? (
            <span className="error-text">{ERROR_MSG.DEFAULT_MSG}</span>
          ) : null}

          <Button
            variant="primary"
            type="submit"
            className="btn-orange full-width edit-create-user-btn best-practice-submit-btn"
            onClick={this.handleOtpModal}
          >
            {submitBtnText}
          </Button>
        </Form>
      </div>
    );
  }
}

CreateBestPracticeForm.propTypes = {
  history: PropTypes.shape({})
};

CreateBestPracticeForm.defaultProps = {
  history: {}
};

function mapStateToProps(state) {
  return {
    groups: state.userManagementReducer.groups,
    rolesList: state.userManagementReducer.rolesList,
    isApiLoading: state.userManagementReducer.isApiLoading,
    isImageUpLoading: state.commonReducer.isImageUpLoading
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      createBestPracticesAction: createBestPracticesAction,
      uploadFileDispatch: uploadFileAction,
      removeFileDispatch: removeFileAction
    },
    dispatch
  );
}

export default PermissionHOC(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CreateBestPracticeForm)
);
